export const SET_AUTHENTICATION_STATUS = "LOGIN/SET_AUTHENTICATION_STATUS";

export const setAuthenticationStatus = (status: string) => ({
    type: SET_AUTHENTICATION_STATUS,
    payload: {
        authenticationStatus: status
    }
});